<template>
  <div id="app" v-if="flag">
    <keep-alive>
      <router-view class="child-view" v-if="keepAlive"></router-view>
    </keep-alive>
    <router-view class="child-view" v-if="!keepAlive"></router-view>
    <add_wechat
      @func="closePFeedback"
      :open-feedback="feedback"
      :apply="isApply"
      :qrcode="apply_qrcode"
    ></add_wechat>
  </div>
</template>

<script>
import Interface from '@/util/interface'
import add_wechat from '@/components/add_wechat'
import {LocationHref} from '@/util/common'
import wx from 'weixin-js-sdk'

// PC 端首页地址
const PC_HOME_URL = 'https://www.yyhmedical.com'

export default {
    name: 'App',
    components: {
        add_wechat
    },
    data() {
        return {
            flag: false,
            transitionName: '',
            feedback: false,
            isApply: false,
            apply_qrcode: '/static/bytx/kefu.svg',
            lastId:0,
            firstLoadingNum:0
        }
    },
    computed: {
        keepAlive() {
            return this.$route.meta.keepAlive || false
        }
    },
    watch: {
        //使用watch 监听$router的变化
        $route(to, from) {
            window.scrollTo(0, 0)
            let pvLastId = sessionStorage.getItem('PvLastId')
            if(!pvLastId){
                pvLastId = 0
            }
            Interface.pvPrint(pvLastId)

            let init_complete = sessionStorage.getItem('init_complete')
            if (init_complete == 1) {
                this.apply_qrcode = sessionStorage.getItem('apply_qrcode')
                this.isApply = true
                this.feedback = true
            } else if(init_complete == 2){
                this.apply_qrcode = "/static/qrcode/default.png"
                this.isApply = false
                this.feedback = true
            }
            this.$forceUpdate()
            this.firstLoadingNum = this.firstLoadingNum+1

            if(to.name === from.name){
                if(to.params && from.params){
                    if(to.params.id === from.params.id){
                        history.pushState({page: 1}, null, window.location.href);
                        this.firstLoadingNum = 1
                    }
                }else{
                    history.pushState({page: 1}, null, window.location.href);
                    this.firstLoadingNum = 1
                }
            }else if(to.name === localStorage.getItem('routerMiniName')){
                setTimeout(()=>{
                    this.firstLoadingNum = 1
                },100)
            }

        }
    },
    methods: {
        closePFeedback(data) {
            this.feedback = false
            this.$forceUpdate()
        },
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase()

            if(ua.indexOf('wxwork') > -1){
                return false
            }

            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true
            }
            return false
        },
        getUserInfo() {
            let user = localStorage.getItem('user')
            if (user) {
                Interface.getData('get', Interface.user.user_info).then(res => {
                    if (res.code === 0 || res.code === 1) {
                        this.user = res.data
                        this.flag = true
                    } else {
                        LocationHref(Interface.api + "/wechat-phase/wxOauth?redirect_url=" + Interface.host + "&path=" + this.$route.path)
                    }
                })
            } else {
                if (this.$route.query.category) {
                    sessionStorage.setItem('category', this.$route.query.category)
                }
                LocationHref( Interface.api + '/wechat-phase/wxOauth?redirect_url=' + Interface.host + '&path=' + this.$route.path)
            }
        },
        unionLogin(unionId) {
            Interface.getData('get', Interface.user.union_login, {
                union_id: unionId,
                path: this.$route.path,
            }).then(res => {
                if (res.code === 0 || res.code === 1) {
                    localStorage.setItem('user', JSON.stringify(res.data.user))
                    localStorage.setItem('access_token', res.data.access_token)
                    localStorage.setItem('user_id', res.data.user.id)
                    localStorage.setItem('uuid', res.data.user.uuid)
                } else {
                    this.error = true
                    if (this.$route.query.category) {
                        sessionStorage.setItem('category', this.$route.query.category)
                    }
                    LocationHref(Interface.api + '/wechat-phase/wxOauth?redirect_url=' + Interface.host + '&path=' + this.$route.path)
                }
                this.$router.push({
                    path: this.$route.path
                })
                this.flag = true
            })
        },
        getUserInfoByUUID() {
            let uuid = localStorage.getItem('uuid')
            if (!uuid) {
                uuid = ''
            }
            Interface.getData('get', Interface.user.uuid_login, {
                uuid: uuid,
                path: this.$route.path
            }).then(res => {
                if (res.code === 0 || res.code === 1) {
                    localStorage.setItem('user', JSON.stringify(res.data.user))
                    localStorage.setItem('access_token', res.data.access_token)
                    localStorage.setItem('user_id', res.data.user.id)
                    localStorage.setItem('uuid', res.data.user.uuid)
                } else {
                    this.error = true
                    this.$toast.fail(res.message)
                }
                this.$router.push({
                    path: this.$route.path
                })
                this.flag = true
            })
        },
        isPc(){
            let userAgentInfo = navigator.userAgent;
            let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");//pc
            return !Agents.some(item => userAgentInfo.toLowerCase().includes(item.toLowerCase()))
        },
        isInIframe(){
            return !!(self.frameElement && self.frameElement.tagName == "IFRAME")
        },
        // PC 端进入首页时，直接跳转 PC 官网
        redirectPcHome(){
            if (this.$route.path === '/' && this.isPc() && !this.isInIframe()) {
                window.location.replace(PC_HOME_URL)
                return true
            }
            return false
        },
        initPc(){
            let width = window.screen.width *0.24
            let height = window.screen.height *0.78
            if (this.isPc() && !this.isInIframe()) {
                let ifrTag = document.createElement("iframe");document.body.innerHTML = "";ifrTag.setAttribute("src", location.href);
                let styleObj = {width: width+"px",height: height + "px",marginTop:"7px",position: "absolute",left: "50%",transform: "translateX(-50%)",border:"1px solid #c2c2c2",sandbox:"allow-same-origin allow-forms",webkitScrollbar:"none"}
                Object.entries(styleObj).forEach(([key, value]) => {ifrTag.style[key] = value;});
                document.body.append(ifrTag);
            }
        },
        initListener(){
            window.addEventListener("popstate", (event)=> {
                if(localStorage.getItem('routerMiniName') === this.$route.path){
                    if(this.firstLoadingNum ===1){
                        wx.closeWindow()// 关闭网页
                        // 检查是否需要返回小程序页面
                        wx.miniProgram.navigateBack({
                            delta: 1 // 返回的页面数，如果delta大于现有页面数，则返回到首页
                        });
                    }

                }
            }, false);
        }
    },
    beforeMount() {

        var ua = window.navigator.userAgent.toLowerCase()
        if(ua.indexOf('wxwork') > -1 && (this.$route.path.indexOf('co_user_detail') > -1 || this.$route.path.indexOf('gb_user_detail') > -1) ){
            this.flag = true
            return false
        }

        // PC 端进入首页，直接跳 PC 官网，后续初始化/登录逻辑无需执行
        if (this.redirectPcHome()) {
            return false
        }

        this.initPc()
        this.initListener()

        sessionStorage.setItem('WxCodeUrl', location.href)
        Interface.getShareInfo(this, '', '', '')
        if(this.$route.query.is_mini === '1'){
            localStorage.setItem('isMini', "1")
            localStorage.setItem('routerMiniName', this.$route.path)
        }

        let union_id = localStorage.getItem('union_id')
        if (this.$route.query.union_id != undefined) {
            localStorage.setItem('openid', this.$route.query.open_id)
            localStorage.setItem('union_id', this.$route.query.union_id)
            this.unionLogin(this.$route.query.union_id)
        }else if (union_id && union_id != '') {
            this.unionLogin(union_id)
        } else{
            if (this.isWeiXin()) {
                this.getUserInfo()
            } else {
                this.getUserInfoByUUID()
            }
        }
        Interface.pvPrint(0)
    },
    destroyed(){
        localStorage.removeItem("isMini")
    }
}
</script>
<style>
html,
body,
#app {
  color: #333333;
  font-family: Arial, Helvetica, "STHeiti STXihei", "Microsoft YaHei", Tohoma,
    sans-serif;
  -webkit-text-size-adjust: 100% !important;
  overflow-y: overlay;
}
.w-190px {
  width: 190px;
}
.h-190px {
  height: 190px;
}
.dialog-span-1 {
  font-size: 10px;
  color: #404040;
  letter-spacing: 0;
  text-align: center;
  margin-top: 6px;
  margin-bottom: 10px;
}

::-webkit-scrollbar {
  display: none;
}

.van-grid .van-icon__image {
  width: 20px;
  height: 20px;
}

.clear {
  clear: both;
}

.page {
  min-height: 100vh;
  padding-bottom: 60px;
}

.van-swipe-item {
  text-align: center;
}

iframe {
  height: inherit;
  width: inherit;
}

p {
  line-height: 1.8;
  margin: 0;
  max-width: 100%;
}

p img {
  max-width: 100% !important;
}

p video {
  max-width: 100%;
}

.apply_form {
  width: 275px;
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #404040;
  letter-spacing: 0;
  line-height: 22px;
  padding: 0 20px 20px;
}

.apply_form .close-pop {
  float: right;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue